import React from "react";

export const MoneyStat = ({ label, valor, destaque = false, sub, testid }) => (
  <div
    className={`rounded-xl border px-3.5 py-3 ${
      destaque
        ? "border-primary/30 bg-primary/[0.07]"
        : "border-slate-200 bg-white"
    }`}
    data-testid={testid}
  >
    <div className="text-[10.5px] font-semibold uppercase tracking-wide text-slate-500">
      {label}
    </div>
    <div
      className={`num font-display font-bold leading-tight ${
        destaque ? "text-[24px] text-primary" : "text-[19px] text-slate-900"
      }`}
    >
      {valor}
    </div>
    {sub && <div className="mt-0.5 text-[11px] text-slate-500">{sub}</div>}
  </div>
);

export const EmptyState = ({ icone: Icone, titulo, descricao, acao }) => (
  <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-white px-6 py-14 text-center">
    {Icone && (
      <span className="mb-3 grid h-12 w-12 place-items-center rounded-full bg-slate-100 text-slate-500">
        <Icone className="h-6 w-6" />
      </span>
    )}
    <h3 className="font-display text-base font-semibold text-slate-900">{titulo}</h3>
    {descricao && <p className="mt-1 max-w-md text-sm text-slate-500">{descricao}</p>}
    {acao && <div className="mt-4">{acao}</div>}
  </div>
);
